import { roles, events, partners, artists, contacts } from '../../../services/api.admin';
import { deleteTableData, fetchTableData, refresh } from '../tables';
import { fetchDependencies, submit as sumbitModal } from '../modal.forms';
import { MODELS } from '../../../constants/admin/settings';
import { v4 as uuidv4 } from 'uuid';
import {
    ALL_EVENTS_PERMISSIONS_OPTION,
    hasPermissions,
    PERMISSIONS,
    ROLE_TYPE_ORGANIZATION,
    ROLE_TYPE_ARTIST,
    ROLE_TYPE_PARTNER,
    ROLE_NONE,
    ROLE_GOD_USER
} from '../../../constants/authentication/permissions';
import { currentUserSelector } from '../../../selectors/authentication';
import { relatedToFromFunction } from '../../../selectors/admin/models/permissions';
import { formDataSelector } from '../../../selectors/admin/forms';
import { stateToApiData } from '../../../selectors/admin/models/contacts';
import { filter, pick } from 'lodash';
import { onInput } from '../forms';
import { selectedSelector } from '../../../selectors/admin/tables';
import { contextSubjectSelector } from '../../../selectors/admin/context';

export function fetchPermissions(userId, _, context) {
    return fetchTableData(() => contacts.getRoles(userId, context), 'roles', {
        transformFunction: x => {
            return filter(x, x => x.name !== ROLE_NONE);
        }
    });
}

export function fetchPermissionsDependencies(context) {
    return (dispatch, getState) => {
        const user = currentUserSelector(getState());
        const dependencies = [roles.getAll];
        if (hasPermissions(user, PERMISSIONS.PARTNERS_VIEW)) {
            dependencies.push(context ? () => partners.getOrgAll(context) : partners.getAll);
        }
        if (hasPermissions(user, PERMISSIONS.EVENTS_VIEW)) {
            dependencies.push(context ? () => events.getOrgAll(context) : events.getAll);
        }
        if (hasPermissions(user, PERMISSIONS.ARTISTS_VIEW)) {
            dependencies.push(context ? () => artists.getOrgAll(context) : artists.getAll);
        }
        dispatch(fetchDependencies(dependencies));
    };
}

export function deletePermissions() {
    return (dispatch, getState) => {
        const context = contextSubjectSelector(getState());
        const contactData = formDataSelector(getState(), { model: MODELS.CONTACT });
        const permissionsToDelete = selectedSelector(getState());
        const newData = {
            ...contactData,
            roles: filter(contactData.roles || [], r => !permissionsToDelete.includes(r.id))
        };
        return deleteTableData(() => contacts.update(newData.id, stateToApiData(newData), context), MODELS.PERMISSION, {
            afterDone: () => {
                dispatch(onInput(MODELS.CONTACT, 'roles', newData.roles, true));
            }
        })(dispatch, getState);
    };
}

export function createPermission(data, userId) {
    return (dispatch, getState) => {
        const context = contextSubjectSelector(getState());
        const contactData = { ...formDataSelector(getState(), { model: MODELS.CONTACT }) };
        contactData.roles = [...contactData.roles, _permitBody(data)];
        dispatch(onInput(MODELS.CONTACT, 'roles', contactData.roles));
        return sumbitModal(() => contacts.update(userId, stateToApiData(contactData), context), _formOptions)(
            dispatch,
            getState
        );
    };
}

export function updatePermission(data, userId) {
    return (dispatch, getState) => {
        const context = contextSubjectSelector(getState());
        const contactData = { ...formDataSelector(getState(), { model: MODELS.CONTACT }) };
        contactData.roles = (contactData.roles || []).map(r => (r.id === data.id ? _permitBody(data) : r));
        dispatch(onInput(MODELS.CONTACT, 'roles', contactData.roles));
        return sumbitModal(() => contacts.update(userId, stateToApiData(contactData), context), _formOptions)(
            dispatch,
            getState
        );
    };
}

const _permitBody = data => {
    const type = relatedToFromFunction(data.function);
    const bodyData = { id: uuidv4(), ...data };

    if (type === ROLE_TYPE_ORGANIZATION) {  
        bodyData.orgId = bodyData.group;

    } else if (type === ROLE_TYPE_ARTIST) {
        bodyData.artistId = bodyData.group;
    } else if (type === ROLE_TYPE_PARTNER) {
        bodyData.partnerId = bodyData.group;
        delete bodyData.accessToClearanceContracts
        delete bodyData.accessToPerformanceContracts
    }
    if (bodyData.eventId === ALL_EVENTS_PERMISSIONS_OPTION.value) {
        delete bodyData.eventId;
    }
    if (bodyData.name === ROLE_GOD_USER) {
        delete bodyData.accessToClearanceContracts
        delete bodyData.accessToPerformanceContracts
    }
    delete bodyData.group;
    return pick(bodyData, ['id', 'name', 'orgId', 'eventId', 'artistId', 'function', 'partnerId', 'accessToClearanceContracts', 'accessToPerformanceContracts']);
};

const _formOptions = {
    beforeDone: (dispatch, _, doneFunction) => {
        dispatch(refresh());
        doneFunction();
    }
};



// WEBPACK FOOTER //
// ./src/actions/admin/models/permissions.js